import { SEND_ONBOARDING_FORM } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

export interface SendOnboardingFormPayload {
  applicationId: string;
  email: string;
}

export interface SendOnboardingFormResponse {
  success: boolean;
  message?: string;
}

export const onboardingFormQueryKey = ['onboarding-form'];

export const sendOnboardingForm = async (
  data: SendOnboardingFormPayload
): Promise<SendOnboardingFormResponse> => {
  const response = await makeAuthenticatedRequest(SEND_ONBOARDING_FORM, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to send onboarding form');
  }

  const result = await response.json();
  return result;
};
